export default __webpack_public_path__ + "static/affiliate-program-Software-2-435d9251a6a439ab9e2726bf13e8738a.webp";